export default __webpack_public_path__ + "static/media/le_touquet18.5ff3b703.jpg";